import { render, staticRenderFns } from "./MerchantUserManagement.vue?vue&type=template&id=1b5e2960&"
import script from "./MerchantUserManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantUserManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports